import { TestPhase } from '../testing/GearTestOrchestrator';

export function isComparisonPhase(phase: TestPhase): boolean {
  return [TestPhase.Comparing, TestPhase.GearTesting, TestPhase.BallTesting].includes(phase);
}

/** Playback speed only: the game loop retains its 1/240-second physics steps. */
export function fittingTimeScale(phase: TestPhase, fastResults: boolean): number {
  return isComparisonPhase(phase) && fastResults ? 5 : 1;
}
